<script setup>
// core
import {ref, useTemplateRef, watch, nextTick} from "vue";
import {useResizeObserver} from "@vueuse/core";

const props = defineProps({
    text: {
        type: [String, Number],
        default: ''
    }
})

const el = useTemplateRef('el')
const isCut = ref(false)
const isScrolled = ref(false)
const isEnd = ref(false)

// the fades show only while part of the text is hidden on that side
const sync = () => {
    const node = el.value
    if (!node) return

    isCut.value = node.scrollWidth > node.clientWidth + 1
    isScrolled.value = isCut.value && node.scrollLeft > 1
    isEnd.value = isCut.value && node.scrollLeft + node.clientWidth >= node.scrollWidth - 1
}

useResizeObserver(el, sync)
watch(() => props.text, () => nextTick(sync))
</script>

<template>
    <span
        ref="el"
        class="fade-scroll"
        :class="{ 'is-cut': isCut, 'is-scrolled': isScrolled, 'is-end': isEnd }"
        :title="String(text)"
        @scroll="sync"
    >{{ text }}</span>
</template>

<style scoped lang="scss">
.fade-scroll {
    display: block;
    min-width: 0;
    overflow-x: auto;
    white-space: nowrap;
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
        display: none;
    }

    &.is-cut {
        cursor: ew-resize;
        -webkit-mask-image: linear-gradient(to right, #000 calc(100% - 22px), transparent 100%);
        mask-image: linear-gradient(to right, #000 calc(100% - 22px), transparent 100%);
    }

    &.is-cut.is-scrolled {
        -webkit-mask-image: linear-gradient(to right, transparent 0, #000 22px, #000 calc(100% - 22px), transparent 100%);
        mask-image: linear-gradient(to right, transparent 0, #000 22px, #000 calc(100% - 22px), transparent 100%);
    }

    &.is-cut.is-end {
        -webkit-mask-image: linear-gradient(to right, transparent 0, #000 22px);
        mask-image: linear-gradient(to right, transparent 0, #000 22px);
    }
}
</style>
